import light from './lightApi'
import h5 from './h5Api'

const Api = {
  light,
  h5,
};

export default Api;



